module.exports = __webpack_public_path__ + "img/cover.30efad09.jpg";